import './assets/main.css'

import { createApp } from 'vue'
import MiniRegistrationView from './views/MiniRegistrationView.vue'
import VCalendar from 'v-calendar'
import 'v-calendar/dist/style.css'



// Wait for DOM to be ready
function initializeMiniRegistration() {
    try {
        
        if (!createApp) {
            throw new Error('Vue createApp is not available')
        }
        
        // Create the mini registration app
        const miniApp = createApp(MiniRegistrationView)
        
        // Don't use router for mini form - it's used as a shortcode
        miniApp.use(VCalendar, {})
        
        // Mount mini registration if element exists
        const miniRegistrationEl = document.getElementById('mq-vue-mini-registration')
        
        if (miniRegistrationEl) {
            miniApp.mount(miniRegistrationEl)
        } else {

            document.querySelectorAll('[id*="mq"]').forEach(el => {

            })
        }
    } catch (error) {
        console.error('❌ mini-main.ts: Error during initialization:', error)
        console.error('❌ mini-main.ts: Error stack:', error instanceof Error ? error.stack : 'No stack available')
        
        // Show error message to user
        const miniEl = document.getElementById('mq-vue-mini-registration')
        if (miniEl) {
            miniEl.innerHTML = `
                <div style="text-align: center; padding: 2rem; color: #721c24; background: #f8d7da; border: 1px solid #f5c6cb; border-radius: 4px;">
                    <h3>Fout bij het laden</h3>
                    <p>Er is een fout opgetreden bij het laden van het formulier: ${error instanceof Error ? error.message : String(error)}</p>
                    <button onclick="location.reload()" style="background: #0099e3; color: white; border: none; padding: 0.5rem 1rem; border-radius: 4px; cursor: pointer;">
                        Pagina verversen
                    </button>
                </div>
            `
        }
    }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMiniRegistration)
} else {
    initializeMiniRegistration()
} 